import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import calendarFill from "@iconify/icons-eva/calendar-outline";
import {Icon} from "@iconify/react";
import api from "../../api";

export default function ActiveDays() {
    const [activeDays, setActiveDays] = useState(api.getUserActiveDays());

    useEffect(() => {
        // api.setUser() 'user-data-updated' event tarqatganda sanoqni yangilaymiz —
        // shunda foydalanuvchi action bajarib streak ortsa, sahifa qayta
        // yuklanmasdan navbar darhol yangilanadi.
        const handler = () => setActiveDays(api.getUserActiveDays());
        window.addEventListener('user-data-updated', handler);
        return () => window.removeEventListener('user-data-updated', handler);
    }, []);

  return (
      <>
        <Typography variant="h4" noWrap valign="center" color={'#00ad4d'} style={{ paddingTop:"5px" }}>
          <Icon icon={calendarFill}  valign="center"/>
        </Typography>
        <Typography variant="h4" noWrap valign="center" color={'#00ad4d'} style={{ marginLeft:"0" }}>
            { activeDays??0 }
        </Typography>
      </>
  );
}
